import { useMutation } from '@tanstack/react-query'
import { consumersDetails } from '../index'

const useConsumerDetails = () =>
  useMutation({
    mutationFn: consumersDetails,
  })

export default useConsumerDetails
